import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Loader from "../../../../Widgets/Loader/Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getOnlyCountries, postDeleteInformationOfSubmittedApplicationsOfViewUpdateApplicationForm, getDocumentsBasedOnEmploymentType, addNewEmployer } from "../../../../../api";

const PopupStage2Empolyer = ({ show, pointerID, onHide, getAllDataOfSubmittedApplicationsFunction }) => {
    const [loading, setLoading] = useState(false);

    const [countriesData, setCountriesData] = useState([]);
    const [selectEmploymentType, setselectEmploymentType] = useState("");
    const [companyNameOrOrganisation, setCompanyNameOrOrganisation] = useState("");
    const [enterRefereeName, setEnterRefereeName] = useState("");
    const [refreeMobileCountryCode, setRefreeMobileCountryCode] = useState("13");
    const [refreeMobileNumber, setRefreeMobileNumber] = useState("");
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const [documents, setDocuments] = useState([
    ]);


    // Handle Employement Type Change
    const handleEmploymentTypeChange = async (type_of_employment) => {
        setselectEmploymentType(type_of_employment);

        if (type_of_employment == "") {
            setDocuments([]);
        }
        try {
            const response = await getDocumentsBasedOnEmploymentType(type_of_employment);
            if (
                response &&
                response.data &&
                response.data.response &&
                response.data.response.response === true
            ) {
                console.log("Documents based on employment type:", response.data.response.data);
                setDocuments(response.data.response.data);
            } else {
                toast.error(response.data.response.error_msg || "Error in fetching documents");
            }
        } catch (error) {
            console.error("Error in fetching documents:", error);
        }
    };


    // ✅ Fetch Countries List
    const getOnlyCountriesFunction = async () => {
        try {
            setLoading(true);
            const response = await getOnlyCountries();
            setLoading(false);
            if (
                response &&
                response.data &&
                response.data.response &&
                response.data.response.response === true
            ) {
                setCountriesData(response.data.response.data);
            } else {
                toast.error(response.data.response.error_msg || "Error in fetching");
            }
        } catch (error) {
            setLoading(false);
            console.error("Error in fetching:", error);
        }
    }

    // ✅ Handle Email Validation
    const handleEmailChange = (event) => {
        const input = event.target.value;
        setEmail(input);

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(input) && input !== "") {
            setEmailError("Please enter a valid email address.");
        } else {
            setEmailError("");
        }
    };

    // ✅ Handle Document Checkbox Change
    const handleCheckboxChange = (e) => {
        const id = e.target.id;          // string
        const checked = e.target.checked;

        setDocuments((prevDocuments) =>
            prevDocuments.map((doc) =>
                String(doc.required_id) === id
                    ? { ...doc, document_check: checked }
                    : doc
            )
        );
    };


    // ✅ Validate before confirmation
    const handleValidateAndConfirm = () => {
        const selectedDocs = documents.filter((doc) => doc.document_check);

        // console.log("Selected Docs before validation:", selectedDocs.length);
        // return;

        if (!companyNameOrOrganisation.trim()) {
            toast.error("Please enter company or organisation name.");
            return;
        }

        if (!enterRefereeName.trim()) {
            toast.error("Please enter referee name.");
            return;
        }

        if (!refreeMobileNumber.trim()) {
            toast.error("Please enter referee mobile number.");
            return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email.trim() || !emailPattern.test(email)) {
            toast.error("Please enter a valid referee email.");
            return;
        }

        if (!selectEmploymentType.trim()) {
            toast.error("Please select employment type.");
            return;
        }

        // if (selectedDocs.length < 3) {
        //     toast.error("Please select at least 3 documents.");
        //     return;
        // }

        // ✅ If all good, show confirmation modal
        setShowConfirmationModal(true);
    };


    // ✅ Submit Employer Details (after confirmation)
    const handleConfirmSubmit = async () => {
        setShowConfirmationModal(false);
        setLoading(true);

        try {
            // Prepare selected documents only
            const selectedDocs = documents.filter((doc) => doc.document_check);
            // console.log("Selected Docs for submission:", documents);
            const formData = new FormData();
            formData.append("pointer_id", pointerID);
            formData.append("company_name", companyNameOrOrganisation);
            formData.append("referee_name", enterRefereeName);
            formData.append("referee_country_code", refreeMobileCountryCode);
            formData.append("referee_mobile", refreeMobileNumber);
            formData.append("referee_email", email);
            formData.append("employment_type", selectEmploymentType);
            formData.append("documents", JSON.stringify(selectedDocs));

            const response = await addNewEmployer(formData);

            if (
                response &&
                response?.data?.response?.response === true
            ) {
                getAllDataOfSubmittedApplicationsFunction(pointerID);
                toast.success(
                    response?.data?.response?.success_msg ||
                    "Employer added successfully!"
                );
                onHide(); // close modal
            } else {
                toast.error(
                    response?.data?.response?.error_msg ||
                    "Something went wrong while adding employer."
                );
            }
        } catch (error) {
            console.error("Error in submitting employer:", error);
            toast.error("Error in submitting employer details.");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (show) {
            // Reset all form fields when modal opens
            setselectEmploymentType("");
            setCompanyNameOrOrganisation("");
            setEnterRefereeName("");
            setRefreeMobileCountryCode("13");
            setRefreeMobileNumber("");
            setEmail("");
            setEmailError("");
            setDocuments([]);
            setShowConfirmationModal(false);
            // Fetch countries when modal is shown
            getOnlyCountriesFunction();
        }
    }, [show]);

    

    return (
        <>
            {loading && <Loader />}

            {/* Main Modal */}
            <Modal show={show} onHide={onHide} animation={false} backdrop="static" size="lg" centered>
                <Modal.Header>
                    <Modal.Title className="modal-title text-center text-green">
                        Employment Details
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <div className="row mb-0">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>▸ Company / Organisation Name <span style={{ color: "red" }}>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={companyNameOrOrganisation}
                                        onChange={(e) => setCompanyNameOrOrganisation(e.target.value)}
                                        style={{ height: "40px" }}
                                    />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label className="mb-0">▸ Referee Name <span style={{ color: "red" }}>*</span></Form.Label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={enterRefereeName}
                                        onChange={(e) => setEnterRefereeName(e.target.value)}
                                        style={{ height: "40px" }}
                                    />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label className="mb-0">▸ Referee Contact No. <span style={{ color: "red" }}>*</span></Form.Label>
                                    <div className="row g-0">
                                        <div className="col-md-4">
                                            <select
                                                className="form-select"
                                                value={refreeMobileCountryCode}
                                                onChange={(e) => setRefreeMobileCountryCode(e.target.value)}
                                                style={{ height: "40px" }}
                                            >
                                                <option value="">Select Country Code</option>
                                                {countriesData.map((country) => (
                                                    <option
                                                        key={country.id}
                                                        value={country.id}
                                                    >
                                                        {country.name} (+{country.phonecode})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-8">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Phone Number"
                                                value={refreeMobileNumber}
                                                onChange={(e) => setRefreeMobileNumber(e.target.value)}
                                                style={{ height: "40px" }}
                                            />
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>▸ Referee Email <span style={{ color: "red" }}>*</span></label>
                                    <input
                                        type="text"
                                        className={`form-control ${emailError ? "is-invalid" : ""}`}
                                        value={email}
                                        onChange={handleEmailChange}
                                        style={{ height: "40px" }}
                                    />
                                    {emailError && <p className="text-danger">{emailError}</p>}
                                </div>
                            </div>

                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label className="mb-0">▸ Employment Type <span style={{ color: "red" }}>*</span></Form.Label>
                                    <select
                                        className="form-select"
                                        value={selectEmploymentType}
                                        onChange={(e) => handleEmploymentTypeChange(e.target.value)}
                                        style={{ height: "40px" }}
                                    >
                                        <option value="" disabled>Select Employment Type</option>
                                        <option value={"employment_documents"}>Full-Time/ Part-Time/ Casual</option>
                                        <option value={"self_employment_documents"}>Self-Employed</option>
                                    </select>
                                </Form.Group>
                            </div>


                            {(documents.length > 0) && (
                                <div className="col-md-6">
                                    <Form.Label className="mb-0">▸ Select Document</Form.Label>
                                    {documents.map((doc, index) => (
                                        <Form.Check
                                            key={doc.required_id}
                                            type="checkbox"
                                            id={String(doc.required_id)}
                                            label={doc.document_name}
                                            checked={index === 0 ? true : !!doc.document_check} // checked if index 0 or from data
                                            disabled={index === 0} // disable first checkbox
                                            onChange={handleCheckboxChange}
                                        />
                                    ))}

                                </div>
                            )}

                        </div>
                    </Form>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-center">
                    <Button
                        onClick={onHide}
                        className="btn-danger ms-1"
                        style={{ padding: "7px 20px", borderRadius: "6px" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="btn_modal"
                        style={{ padding: "7px 20px", borderRadius: "6px" }}
                        onClick={handleValidateAndConfirm}
                    >
                        Add
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* ✅ Confirmation Modal */}
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to add this employer?</Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowConfirmationModal(false)}>
                        No
                    </Button>
                    <Button className="btn_modal" onClick={handleConfirmSubmit}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PopupStage2Empolyer;
